import * as types from "../../actionTypes";

export const get = (pageNumber = null) => {
  return {
    type: types.MANAGER_GET_CONTACT_DETAIL_REVIEW_REQUEST,
    pageNumber
  };
};

export const getSuccess = data => {
  return {
    type: types.MANAGER_GET_CONTACT_DETAIL_REVIEW_SUCCESS,
    payLoad: data
  };
};
export const getFailure = error => {
  return {
    type: types.MANAGER_GET_CONTACT_DETAIL_REVIEW_FAILURE,
    error: error
  };
};
